import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isOfflineSyncEnabled } from './isOfflineSyncEnabled';

export function isShadowPDVEnabled(viewerMailboxInfo: MailboxInfo): boolean {
    // We are intentionally not passing in MailboxInfo to below
    // flight checks because framework sync currently is
    // completely conditioned on the global settings mailbox account's
    // flights since they have some trouble at this time
    // to completely flight offline by account.
    return (
        isOfflineSyncEnabled(viewerMailboxInfo) && isGlobalFeatureEnabled('peo-offline-shadow-pdv')
    );
}
